import React from "react";
import { Flex } from "@chakra-ui/react";

export const Container = React.memo(({ children }) => {
  return (
    <Flex flexDirection="column" width="full" alignItems="center">
      <Flex flexDirection="column" maxW="5xl" width="full">
        {children}
      </Flex>
    </Flex>
  );
});
